import './App.scss';
import Header from './components/layout/Header';
import Home from './components/home/Home';
import { section } from './interfaces/SectionInterface';
import sectionData from './Assets/sections.json';
import './i18n/config';

// Legacy imports (simple pathname-based routing to avoid adding react-router)
import LegacyHeader from './components/legacy/LegacyHeader';
import LegacyHome from './components/legacy/LegacyHome';
import LegacyFooter from './components/legacy/LegacyFooter';

function getSections(): section[] {
    return sectionData as section[];
}

function App() {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '/';
  const isLegacy = pathname.startsWith('/legacy');

  if (isLegacy) {
    return (
      <div id="App" className="legacy-app">
        <div id="content" className="legacy-content">
          <LegacyHeader />
          <LegacyHome />
          <LegacyFooter />
        </div>
      </div>
    );
  }

  return (
    <div id="App" className="site-app">
      <div id="content" className="site-content">
        <Header sectionProp={getSections()}/>
        <Home/>
      </div>
    </div>
  );
}

export default App;
